import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

// Per-role landing page when an unauthorised role hits a guarded route.
// Anything not listed here falls back to "/" (admin Dashboard).
const ROLE_HOME = {
  vendor: "/supplier-portal",
  in_house: "/my-work",
  vendor_operative: "/my-work",
};

/**
 * Wrap a route element with `<RoleGuard allow={[...]}>` to bounce unauthorised
 * roles to their own home page rather than rendering a screen they shouldn't see.
 * Useful for admin-only pages so supplier / in_house users can never accidentally
 * land on Edit / Assign / Delete UIs (e.g. via a deep-link or notification).
 */
export default function RoleGuard({ allow = [], children }) {
  const { user } = useAuth();
  const navigate = useNavigate();

  const role = user?.role;
  const denied = !!user && allow.length > 0 && !allow.includes(role);

  useEffect(() => {
    if (denied) {
      const dest = ROLE_HOME[role] || "/";
      navigate(dest, { replace: true });
    }
  }, [denied, role, navigate]);

  if (!user) return null;
  if (denied) return null;
  return children;
}
